import { Component, OnInit, ViewChild, AfterContentInit, ElementRef, ChangeDetectorRef, Renderer2, OnDestroy, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { FileUtil } from '../../../shared/helpers/file-util';
import { Observable, interval, Subscription } from 'rxjs';
import { takeWhile, debounceTime } from 'rxjs/operators';
import { SemControlComponent } from '../sem-control/sem-control.component';
import { FileDataModel, ClientAction } from 'src/app/models/file-upload/file-data';
import { RequestModel } from 'src/app/models/request/request-model';
import { type } from 'os';
import { SemFileExplorerComponent } from '../sem-file-explorer/sem-file-explorer.component';
import { RestProviderService } from '../../../services/rest-provider/rest-provider.service';
import { LocalStorageService } from 'src/app/services/local-storage-service/local-storage.service';
import { SemDialogComponent } from '../dialogs/sem-dialog/sem-dialog.component';
import { SemFileExplorerDialogComponent } from '../dialogs/sem-file-explorer-dialog/sem-file-explorer-dialog.component';
import { FileDataRightModel } from '../../../models/file-upload/file-data-rights';
import { DialogType, ResponseStatus } from '../../../shared/components/sem-dynamic/sem-dynamic.component';
import { environment } from '../../../../environments/environment';
import { ProXSignService } from '../../../services/pro-xsign-integration.service';
import { ThisReceiver } from '@angular/compiler';
import { proXSignUtil } from '../../../models/proXSign/props';
import { DynamicLoadingUtil } from '../../../shared/helpers/dynamic-loading-util';
import { SemConfirmDialogComponent } from '../dialogs/sem-confirm-dialog/sem-confirm-dialog.component';


@Component({
  selector: 'sem-file-upload',
  templateUrl: './sem-file-upload.component.html',
  styleUrls: ['./sem-file-upload.component.css']
})
export class SemFileUploadComponent extends SemControlComponent implements OnInit, AfterContentInit, OnDestroy {

  files: FileDataModel[] = [];
  deletedFiles: FileDataModel[] = [];
  multiple: boolean = false;
  imgPath: string = "";
  toConfirm: boolean = false;
  public showSelected: boolean = false;
  fileDataRight: FileDataRightModel = new FileDataRightModel({ "WriteRight": false, "DeleteRight": false });
  event = null;

  //Inputs
  //Supported file extensions
  @Input() availableExtensions: any[] = ["png", "jpg", "jpeg", "pdf", "doc", "docx"];
  //Type of file upload
  //  (can be images = 1,
  //  attachments = 2, files with section = 3), type depends how we show data in html
  @Input() type: number = 1;

  @Input() title: "";
  @Input() dropText: "";
  collapse: boolean = false;
  @Input() fcategory: "";
  @Input() categoryEditable: false;
  @Input() protocolName: any;
  @Input() imagesPath: any;
  @Input() defaultCollapse: boolean = false;
  @Input() filesectiontype: any = "";

  @Input() onlyOneFileAllowed: boolean = false;
  @Input() customFileTextAppend: any = "";
  @Input() deleteEnabled: any = false;
  @Input() previewDisabled: boolean = false;

  @Input() enableProXSign: boolean = false;
  @Input() proXSignFileSectionType: any = 0;
  @Input() signInstructions: any = "";
  @Input() certProp: any = "";
  @Input() boundedProperty: string = "";
  @Input() boundedTitleEval: string = "";
  @Input() boundedConditionEval: string = "";
  @Input() isInNgFor: boolean = false;

  @Output() collapseChanged = new EventEmitter();
  @Output() saveFormReq = new EventEmitter<string>();

  //Html iput type file element
  //@ViewChild('fileUpload', { read: ElementRef, static: false })
  private fileUpload: ElementRef;
  @ViewChild('fileUpload', { static: false }) set content(content: ElementRef) {
    if (content) { // initially setter gets called with undefined
      this.fileUpload = content;
    }
  }

  //Html div dropzone element
  @ViewChild('dropArea', { static: false })
  private dropArea: ElementRef;

  globalInstance: any;

  //Mapped browser File objects to custom object, which consists of id(index), path(generated from URL.create from File object) and name. We need this array,
  //to be able to show images in html
  filePaths: any[] = [];

  //currently selected File, so we know which file to delete, download, ....
  selectedFile: FileDataModel = null;

  //index number, from which we select images, to be shown in image slider
  index: number = 0;

  //files from index number, which will be shown in image slider
  shownFiles: any[] = [];
  ddAreaDisplay: string = "block";
  dropareaActive: boolean = false;
  showLoader: boolean = false;

  downloadInProgress: boolean = false;

  //files from model
  modelMedias: any[] = [];
  alreadyExists: boolean = false;

  @Input() filesSubmitRequest: Observable<void>;
  @Input() filesSubmitEndRequest: Observable<void>;

  s1: Subscription;
  s2: Subscription;
  s3: Subscription;
  s4: Subscription;
  s5: Subscription;
  s6: Subscription;

  @ViewChild('fileExplorer', { read: SemFileExplorerComponent, static: true }) fileExplorer: SemFileExplorerComponent;

  public restService: RestProviderService = null;
  public proXSignService: ProXSignService = null;
  versionNumber: string = "";
  versionText: string = "";
  proXSignLib: any;
  proXSignAvailable: boolean = false;
  proXSignFileDownloading: boolean = false;

  fileDataActions: any[] = [];

  super() { };
  /*ngOnChanges(){
    console.log("Model in FU control Changes", this.model);
  }*/

  delay(time) {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  ngOnInit() {
    this.restService = this.injector.get(RestProviderService);

    this.s1 = this.filesSubmitRequest.subscribe(() => {
      //this.fileUploadService.files.push.apply(this.fileUploadService.files, this.files);      
      for (var i = 0; i < this.files.length; i++) {
        //if (this.files[i].Action != ClientAction.Old) {
        this.files[i].Category = this.type;

        if (this.enableProXSign) {
          if (!this.files[i].FileSectionType || this.files[i].FileSectionType == 0) {
            this.files[i].FileSectionType = this.proXSignFileSectionType;
          }
        } else {
          this.files[i].FileSectionType = this.filesectiontype;
        }
        this.files[i].FileCategory = this.fcategory;
        this.fileUploadService.files.push(this.files[i]);
        //}
      }

      this.fileUploadService.filesToRemove.push.apply(this.fileUploadService.filesToRemove, this.deletedFiles);
      this.fileUploadService.filesNumber = this.files.length;
      // use this property "filesInfo" if you want to access info about images in preSubmitJS event
      this.fileUploadService.filesInfo = this.fileUploadService.files;
    });

    this.s2 = this.modelChangeNotifier.subscribe((p_model) => {
      if (typeof this.files == "undefined" || !this.files) {
        this.files = [];
        // use this property "filesInfo" if you want to access info about images in preSubmitJS event
        this.fileUploadService.filesInfo = [];
      }
      this.getImages(p_model);

      this.getMediaRights(p_model);
    });

    this.s3 = this.dfms.modelMTOValueChanged.subscribe(p_model => {
      if (this.type == 1) {
        if (typeof this.files == "undefined" || !this.files) {
          this.files = [];
          // use this property "filesInfo" if you want to access info about images in preSubmitJS event
          this.fileUploadService.filesInfo = [];
        }

        if (typeof p_model != "undefined" && p_model && Object.keys(p_model).length > 0) {
          var currPath = this.fileUploadService.imagesPath[0];
          var currAdded = this.dfms.getValue(p_model, currPath + ".AddedFiles");
          if (typeof currAdded != "undefined" && currAdded) {
            /*currAdded = [];
            currAdded.push({
              "Name": "person_0W2DUKR.jpg",
              "FilePayload": "/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wAARCAGLAT8DASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDLooor6M8IKSlooAKKKBQAUUUUAFJS4ooASlpKKAFpKKKACiikJA6mgBc0lMMyD3qJrk5+Xis5VYR3ZrGjOWyLNHSqLTM3Umk8xiuMnH1rB4umbrBzLxIAySB+NLkeorO3E0u4561P1yPYr6lLuaO09aSqS3Dg/ePFTLdbvvj8q1jiKctEzKeGqR1sT0lIrq/Q80tb3Odq24UUUtAB2pKWkoEFLRRQAZpKWigAoBopwciIphcE5zjmgaEJ/KkyaM5ooAM4opKXtQAvekopaYgpaTtRQIKKKKBhRRRQAUlLSUAFFFFABSUe/aq0sxY4HSs6lRU1dmtKk6jsh0k+OFqu8jOc5ppPPNJXlVMROb30PVp0IQ6aikmigCnbCDWF2zcb3oxUiofSniFsdDRYCHGBSY4qYwMoXcCN1NKMPpQAwDijvT0QnrwKYVIagBQxHSpY5yDgnNRRFBIDIu5e4zSMRuOBgdq1p15QejMqlKM9Gi+pDDIpapRSlTx0q1G4ccda9SlWjUWm55dWhKm/IkpKWitjnEopaTtQAtFJRQAtFFJQAtJSk57UUDEopaSgB1FFFMkKKKKAEopaKBhRRRQAUlLRQAU3NKagllAGBUykoq7LhBzdkMmmzwOlVyeaVjg8UAZrxa1WVSV2ezSpqmrIUjODT4oHlbCjNXbGwa4XlcDHWui07SVQDK1jc1Ofh0uR8EitGPSVK8DIPB9q6aLT1UcCp47by8/KDRcdjmE0cIPudDUqaaFc5HAx2rpVt8nkVIbVDzt5o5hNHLXemhvmUcY4qnHpR8srjIzXXva4zxxTBaDsMGnzCONudMYYVR04qlPp0kajue9eg/YUZs7Rg1FLpiOOVFDYzziSBozgjmoipB5rtrrRPl3Bc1h3ulmMEgH6UaAYgp8blGBpZFKNjFM2461UZOLuhSipKzL6sHXIp3WqCSFSMVeRwy5HWvYo1lUXmePWoum/IU0lLRWxziUtFFABRRRigAoooNAxKWkoNADjRRRTEFFBooAToaKWkoAKKKKACl4pKKQEU0m0cVUZiTmpZm3MRUQHNeViqrlLl6I9fDUlGCfViqu81q2GlGVlJP4YqDTbbzZOmQOtdnptmsaA7a42zrsP0/TVjiAI/StSOFUGAKVFwOKeKgACinbc0DrUgHFMlsaEpdtOpaZNyIr7UoQDtT6KAuMIppFSYppFA0yFlz1FUrmySQEHGDWiRUUi8Ui1qcdqmkwqSR1rnriARkg9q9Bu7cSZ4Fcvq1g2ThRkelUmFjn9oxnFSxyYb2qOVWQ7ajBOa2pVHTlcxqU1UjZmjS1XgfPyk/SrAr2YyUldHjTg4OzCjPNFFUQFFFFABRRRQMKSiloAWiiimISilooASloooAKSil7UAJTZX2L70+q1y3zAVlVnyQcjWjD2k0iE/NVqysjcOATgd6ihiaRgFFdDp9oUCjHNeHJ9We9FFzTrKOEAKvHat+3TaBVe2g2ICauLwKyKJVpwpi08UyGOUc1JUYp2aZDH0U3dRmmTYWlpM0hNAC0UgNLmgBhGKjYVKxqNuaRaKsqZrNvLfchBGT61rlearXEe4cdaRocPqllglgAMVjEYNdtqFsJEYEda5K9tmhlIPSrTuS0Qo20g1dBB6VnjrVyA5TGa9LB1LpxPOxlPaaJaKWl7e1d554lApKXj1oBBxnk0lL7ZoOAeDmgAFIwwSBSg4o69aQwoooqiQoo70ooASijNFIBKKKWmAhIAyapOS78VZuGxHiq0X3wK87GVNoHpYKno5m1pFozYYrXTW8IUD1qhpUW2IcVrxLXlyd2emiwg4qUDFMQVJikA4U4GmdKcKZLHg0uaaDSg0Ei5pc02lpiFzxSZoopgLmikFFAAaaaWkpDQ0jNQyLmpyKjcZpFIz7m3yCRXNataBlJxhhXXSLlTWBq1uCpNNDOMZdrEGprYndUcy7ZD9aktzhvrXXhnaojkxKvTZaxxmil49Tikr1zxxaSlzRmgA7UlKCNpFA9BQAZpPSlx3ox7UDDtRRRTJDtRRRQAUGiigBKKKWgCC66Co7Zd0qj3qW56UlkhedQOua8rF/xD18H/AAzsdPGIR61pxDiqNkAIQBVxDjjNeedxbQcU8DNQiRUGWOBUTalAnfNAF3HFAFUYtVgkbAOKmF/bE481c/WmTZlkU4CoI7qBukin8asK6suQQaZLFxSYp5IxxSdaCRtHenEcUCgLiU0nFOJFNOPWgaAUYpjTRp951H41H9tgP8YNAyY0xqjF5CxwrgmnlgRwRQNEcgrI1NN0ZOO1aznIqheJujYe1Io8+uBiVh70kI+cVNqKeXdOB61XiPziuii7TTMKqvFov4pQMEZ6Ugpa9s8MbS9KDzSUwFNFAopAGKKAaDQAUUUqkA8+lMQlFL3o4oASgUUUAFFFAoAhuPuirOjoWuVOOKqXPUVv+HI8xFz615GMf7xns4Nfu0bsS4UUTzrAuep7CnDtSLEDJuPJ964DtKyRT3nLnC+lTHTUK7WNXd+0YFN3jqxxRcDNk0oIh8tuaptp068g/lW750TfKGGfrUbhccMPzpXHoY0cE6ck8jtWjaTyx4yTg9acR6UK209BT5inE1IZSy1YQ8VSgcEcVcTpVJmM0OJqCecxqSOtTN0rOu3680NhCNzKv9RugxCMc+grOXULw7lZnLZ/CtV1Qnpk01YkzkgVHMbcpmwpdSuS5Ygmr0FjMxyxwPTNXovKA6irCSxjuKaZLsVV05yPvAfSlSK4siWRjIp4IJ6Vd8wHoRTtwcYqrk2IY7lZRxw3cU2QbgRSmBRJuHBpJOlAji9ft/LuN471kxn5hXS+I0JTOBXORLl8VvSV5JGVR2i2XR0FLSClr3TwA70daKKBhjHWkpetAH5UAFB5PFBNLjPpSGJRRiiqJCilxSUAGM0EYJFFFIAxRSiigCC5Hyiul8OpixX3rnbhfkzXSeG+bJfrXk42Pv3PXwT9yxrkc0bgoqRlqnduyxnaMmvPZ3rUivdQS3iLFuewrnLjWriXcM9elN1EXMsmGGRngCr2h6UjOZLgbiBwtUkhSdihDqV1G5bJbjkGpTq8ypyfm9MVNqlsYhMUXGGycDtVaytkndwFYpkbSwwTV2RFzU0/VfNQB2G70NaiuH5HSsm90FY1EsDFeOR6Gr2jpL5WyU5I6GsmkbRk7Gjbthq1YuRWUi/MRWpb8KM00RUeg6XgViXjksa3JhlaypbcySYxRJCpuxmPMETpk1Rur8QgE4dj/DnpWhqEHljav3jUdhocLbpZRvOPlBNSlqaSk7XMKXVLh5MK21R2FEupzkLhycck+tO1G2MdyGMZaMH5gvWnaZa7nhDpyWyQfStVaxi2Nt9duIn+YAg10tjercRh1NY+uaTHkPbrhj1Ud6p6c11aShUQkMcHd0FS0i4tnZK27rSsuVqvbkuBnrVvaaEKRz3iFMWzEdhXIRn5xXceIIi1m+OuK4YcSVtR+NGVTWLNDtRTQeBS17x4AuKXAo6UUihAKKXBpKBBjiig9aM0AOxx60lHalpiEoNLSUAHaiiigAHBzRRTlG5lHqQKGNK+hDOwK4HOK6fwyv8AoI+tVZ7OBLIiJVyR16mtjR4Ehso1UY4rxsRWVV6dD26FB0o6vc0Ame1QzQbhVtAMUrLmuNo6UzFubFSuQBmq8cckBAXrW60ee1RNbFj0oKMieMzn5hhvWpbayVGDFslemRitD7F1OakS045NO7E1Ei2JN8r5apEtY4vmjXFWY4lToKSQ9hQTfsQKuXzirsQwBVdRzVqOhClsOccVUIw2RVxjxVcjmqIiVntI5PmddzHvVURiGU4JA9O1aoXjFRSQg5yKm3Y0UujMa8tI5j5jNtJ9KigiitTlQWLDqa12swRxTfsXTNGo7RM1g00mCMVZTTwVBxzV5LYA5xU6pigOa2xVgt9lWCmBUoXFNfpQS3cxtZX/AEVvpXBNGzTMEUk+gFegaxIq2zbs4rmNFkgS7lnlKhRkDPWtIy5XcTjzKxkSJImN4Knr0qwnK1tyLHqKySlPl2/J61hIpQlT2PFerhq/tb3PLxeH9klYkoIoorqOITnFGO9HrRnimAY4zikHPSlJ7UdKAFopKKCReaUsTSUZoKuBpPWl70h4zQIUcGnxcTR/7wpmaAD5iNnowpS2Kjujevk8uJsHA7e9a+msGtI/pWfLEZbYkjPHBq1pZIt0X04r5xaNn0ktbM2I8Yp+M1DG3FSBqCLEoUUbaaGp4NBLuNKcUbeKkHTmmmmK4wjionFSmoZGxSZpEQdasRniq8IycmrSCmhSFbOKhPXmrOOKry9OKZEWPXmlK5pkTZFTAUgegwL7Uu2nUhYCmK4m0UYoLjFN30DSYrcVDIcDNPLVDKeKRSRka4c2cn0rnLTSvPs/O3EAnpXSah+8wh7mq62TRRlEJABzRcuI2GERRLGBjjFc5cDF3IuOhrrIYWLgtnNcxqCgalOB03V24D42cuYtezRB2oHv0o74o6V6p4oUh64BoopgIeaXpQDQDg5/nSAUdKKOlFMQUUDHrSUAFFFKKAEpTnYaOtOAxweaBo6fQz9q01M8kDBNT26mKRk9DVfw3tTTSVbJLHI9KuMCJyW4zzXz9ZWqysfQ0Xekmy5GalB5qvHmplrI1sTDFPBqIU7NUZtEoNBNRg07NBNhG4FQEAnJqSVsKaoyzkD5QSfQVNzSKLaMAcVZQ8VzLX91FdqskWY2YDI/hrXS6460KRU6bNBmwKgZgWxmqk16EQsWAA71nxaqZZf3cMhT++RgU+YUabNsDa2fWp1PFUYZjJgYq2uQMUJkSRJmmtRnFNJqiEhjUlKaaTQaIM1FKc1J0qKTpSBmdKpe4QVpCAeXg1WijLzhgOB3q4G2qS1JhchZVQFugArhbuQTXc0g6Fq3fEOsoiG1tXDSN94qc49q5wDAFepgqbinJ9TzcdUUrQQpHek6U7tzTa7zzg60UUUwCgHFIaUDJpAhaM0lA60xDj+dJxSHrRQMMZpQP0oPSkBoAXvwKcvNJkUqmkykafh65eLUPs+f3cnP410tyPnVq4y1kMN7DKvZsV2biSTYuwgtyK8nHQtNS7nrYKd4NPoOjPFSqaa0DQgbiDn0oFcB3LUmB4pwNRA07NVcTRIDTt1Qg08GlcTQrciqLxkNuWruajK5pMqLsVvKEqkOBTGiKcDpVvbgU1l3Ui7lX7N5g+cZHpThGy8IoFXEUYpwUCiwucZaxbDk8mrXSoh1qTPFWjGWrEJpCeKQ00nincEhTSGkzQKCgNRTEBalJqrcHigTJLYHyj7ms3W7t7Wykfdgn5V/KtO2YCL8K5DxFefa7lbdT8sZyfrW1Cm6k7GNaoqcW2ZEIJYyPySal/lRjHSjtya9xKysjw3Jyd2JRRSn60xCUY70v19KSgApewpKDzSAKKKKokKKKKBhRRRQAUoNJxniikArE7etdhpU07aMsl44z/Ax/SuRSNpJEQAksQAAM5ra8U3Rt4rSxiYDYA7AHkHtmuHG2skd+Dvds3Y23c1OBxWdpc5ntY5CCCw7itEdK8hrU9dMWnCmZxTlpFC5wKUHig8Cq88pQEgZxSuCVyxmmmVR1IrKl1JlGArA/SqbXzM2Njk/Si5cabZv+fHkDd1p25cdRWGsxIztIpy3LDPWi5XsjbWRRwWp4cHoawluDjnNON0ynIDU7kukbmcUgkGaxBqMynHls+akW8dmH7tx60XJ9mzZ3UjVBBIXUZ61P2pp3IasxhpN3FK1MwTTGBJqGbnirBGBWbqk/wBntpJP7ozTRLLhkiuhJYQShZFTLY681wcttJZ3MsMo+ZW/OpdH1CaHWopt5zI4VvcE1qeKowmph+7rzXo4R8s+Xuebi1eFzFoAzR39qTPFekeaObrSU2l/lQFxePWk70YooC4E0UlFAhaO1FFABRS44oxQAlFHejvTASlpKdQBLDcNDLFJkkRNkCujvrG28RLHdwSqrgBW+lcseQagiuZrYt5UjJnrg4rjxNLmSaOzCzabR28UaWbLbI+4IoGc1fjcECvPrO/kgu1lZmYd8nNdrZ3CzRq6kEEcV5NSDiz14Sui81Kppu7IpVrI1JM5FMKA9qeAMU09aQkQS2qMPu1ALZQelaHao24oTKUmiuIkAwQOaFiiH8Ip7YNR7MdzT5jS7ZIIo/7opfIU9hSINtWEbNPmIbYkVrGpzt5pzwITkCpAaGPpS3Mru5Cq7DxUmeKMUGhDeo3GTSjA7UoGM0xjVAMmfaDWTNEmqRz2qzbZB6GpNWvltbd3J5A4Hqa4uG/uIblp45Csh6kd61pwcmZTlZHV6X4di02R73UHQrEMqpHGfWsTU777ffSSgkx5wmT2qneate3qCOed2Uds4FJGMIBXqYek4tylueXial0kh9HFKQOMUhFdRxiYpcce1JRnimAUUUZ7UAJS0ZpVOKAEoo7Uvb3oEJS44zQOvrSd80ALSU7jFIOtAWE+tFL0ooAQ4qN4w3PQ1JS8d6TSasxptO6KrxFRmtHRdS+zSCKQnYx49qrMNy4qo6lGrgxNFJcyPRwtdt8stz0SGUOoIqyhrmtAvXltsOc7TtzW+kma8qSsz1U7otYoIFRq+aeGqQHBaDFmnKRTweKdiW2iBoCRxUfkMaujpRgU+UPaMqiA1IkWOtTYpccUconNsZijFKTSE0CDFMNKWqJ5KQ0hS2BUE0oVCaHlAqpLmVSBwKaKOR129N1dlFPyJxWakbN0FW76Ifb5FXoDSgYGBXr4aiuW7PKxNdqXKiFIMHJOanGO9BpK7UklZHBKTk7sWlpB1paZIlAoo7UAFH1o4FFACUtJS0AFFFKaADNJRRQAUpPakoxQAvag9KKSgA7UUUUAFRTJkZFS0pHFKSUlZlRk4u6Nvw7GslgQFAYMcn1rVBaJsMKy/DJxC6/7Vb7RrIvI5r5+vHkqOJ9BRlzQTIklFSrICaqSQtCcryKaspHesTY1EenlwBWclwO/WphNnvTuTYvo9P3A1RSbnrTnuduMU7icLl3IppfiqwnBHWmtP70XFyE5cUwv71WacDqajef0pXKsSyz44FQPPgdageQk4AyakhtmkYGTp6UhixK85ychalnAhhYqOQO9WVUIuAOKgvP9Q+fQ1S3IZwjMZZnlbqxNFBADMP8AaNFfSRVlZHzs23JthSUtFMkB7UtJS0AJ3xRQaSgBaUDjgU2l70AgoopKAFzSg4pKWgBKWjigUAFJS5pKACiiimAUUUtIBBS4oo4oGbXhk/6wf7VdKOlcv4aP7yUehFdOvQV4OM/jM93Cv90hxUEdKoz2w3ZXitAdKjlXIrmOky2Rh1FIGYdDV7bnrTTAp7UhplUTMDThcHuKmNopBweab9i45JoHdERuD2ppnOetWBZp3JpwtIx/DmgNCqHZj8oJqVYnk68CraxgDAGKdjFMlsijhCnpVpFwKZGuTU4GBTJEIwKrXn+of6VZY1WuRmJh7ULclnCP/rH/AN40mKtzafd+a7JEWXJ6VWeOSI/vI2X6ivo4TjJaM8GpTlGTuhtFJuU9DS5zVmQtFJSigApKd1570mKBic4ooooEFFKAMc0EYHbFA7CUUUUyQooooGFFFFABRRRQAtBpOnWnKoYEs4THrSbS1Y4xcnZDc4FCCSQ4ijZz7CnWYia5xcMGQDIAPWt633lRiMRp2UVw1sbCGkdTupYOUtZaC6DZtBGzSZDseRW6npVK1GKurXkVKjqScmerCChHlRKKSTpQDStyKkordDThSkUbT2oAcMUuKZ060u4+tIYuAKSj60lMBSccUlLj1pVFMTJI6eaRRgUHigQ1jiq8hyDVhhzUUg4pCM+SIsp2sVJ7isK8ttQt2LRO06N1DAGumVe1K0OR0zVKTWqBpM87+ZXw424NaEEK3C4t5AzjqrcflVrxJbrFMhA5asxrG6t7SO9KssbNgHoc110sVOKOWrh4T3LUtrcQ/wCthdR64qMEEdOa3dA1hbhfs1+65H3Wfv7VpXXhq2vB5ts/lsf7vSu2GMi/i0OKeEcfhORoPHer99ol9ZEloi8Y/iWqCsMYrrUlJXRyuLi7MSjFOb26Ug5pk2BhjHtSfw9O9KeVB9KGGAAaBsbRThGx/hP5U7yn/uGndC5WR0v1qTyZP7uPrxSeVj7zrRdD5WR/SlHNOHljrk0plHRUouHKurEVS3QUojJYIo3OegHJqzaWF9fOFiiZFPViMCut0rQoLBdxG6Q9WNc9WvGnvudFOg5nLS6abG0+033AP3UHU1h3Fw0rdNq+gr0HXdFbVXQCXYqKcD1NcPqWlXOmzFJ0+Xsw6GvLqYmVR2bPRp0YwWiF0WIS3Yzzjmutjj4zXI6POIL1d3RuK7SP7gNcs9zrhsOhGKsrzUEYqdKgbJAKWkFOpiI2PNCmkcU0Eg4pgSkZpNgoU0ZoGG0Uu0UnUYpdwFAhKUGmk5PFKo9aAJe1FJmjNAhTULipCaaeaQiFF5qYAY5pgHJomfZEx9qYMWxt4ppZJnjV8HAyM4rL8aTRpp6Qjbu3g4rVeZNL0lppOCq5+prgXkutb1IAktJI3A7AVUUZvVlSGOWeYJEhZz0Ar0Xwza3Nppojul2tnIGe1P0XRLfS4RhQ0xHzOfWtSruyWwKhhggEVl6hoVpeRtiMI56MBWrRVRnKDvFkSipKzOMn8Kyq37qXI9xVRvDl+PuqDXekZqMrzXXHGVDneGgzgTompR8+RuH1qnPFPE2JomQ+4r0sIMc1HLaRS/fQH6irjjXf3kRLCq2jPNjKx/iNG9l5O4Z9a63SvDsdqfMuD5knb0Fasum2sybXhUjOelbSxcE7JERw02rtnnZkBFTQWtxcsFhiY++K7yLSbOL7lui/QVaS3jT7qAfQVEsauiKWEf2mcta+E3kUNcTYJ/hArWsPDtrZyFsFyRj5q2AMUtck8TUl1OiNGEdkNSNYxhRgU6iiuc2GY5JqveWsV3CYpkDIfWrQFNYVkykzyvULVrDUJYSCNjnaT3HY11unSmW0jZiCSO1Q+NbLMMV0q8qdrH2rP8PXJMbRn+E8U3qjWG50sQ4qYDmoYGyKnHPSoKDvS5pKYW5pjHtTDSg5pSKYIb9KN3NBGKSgBdxpMkminLQA5R+FSKMUwYp4oEHejNNZsU0HNAD6TFKBS0WER9KjK/aJ0iGSActjtUsnCmuR1PUr6x1cyxl4lGAAejCml0JbOg8Z5XRQB0MgBqv4JsUW0e8IBdmKg+gFZeua3Dq+lQZG25jfLJjjp2rq/Djq+h2u3suKu2hn0NKiiimSLRRRQAlGKWigBKKWigBuKMUtFACAUtFFABRS0lAC0lFFACUmDilpazGYnipAdFmJ7ViaHDBb6JJcTSKhduCa2vFzhNEkBPLMAK4KL7RdyRWsZZsnCLnimldFp2O3tZAyAqcg9KvJyKzLTTpNMtUE84cntjpWhHU2NL3JdvFRulTpyKVkBFFhplJW2tg1OvIqKePHIpbds8UihzCm1OycVEV9qYDKUGnBCacIvWgBY+al6CmqMGnsKBMixuNOCY7U9Up/Ap2JuR7cU7bTgA5Krz61z2t61daZeRwLFtjAzludw9qZLka199shjEttAs2OSpODio43sfENm0U0e2ReGUjDKa1oJBLBHIvR1Bqje6aWuUvLQiO4Xr6OPQ07W3M73OD1nSJtKn2OC0bfcf1rqPBFz5mnywk8xtwPaty7tItQszFcJw479VNcnoySaJ4iNnNkRy8Bj39DTT6BujtqKKKZIUUUUAFFFFABRRRQAlLRRQAlLSUUALSUUtABTXdUA3EDJwPenVheK7hraxhlQ4ZZQaBo3KKq6deJfWcc6Hhhz9asO4jRnY4CjJNQBy/ji4T7NBbhgXL7ioPOMUvhPRjbp9suYisrfcDDkCqNsh13xO0jjMUfX8K7YAAADoKOg27aFf7KrTGVwGbouf4RWF4k1X+zZY4oYw0j8knpiumNcj4u0eWSQX1shdh98KOfrSsrjTNm0eR7WOWRNpZdxAOcU4Tq4yjBvoa5Wy8Vz21p9nuoBNjjLcHHpWVPq0zXLS2+YFJzsU8VVtS1Lud67ZyKhj+SSuYttfvxAZXhEsSHDN0xWtpWsxX9wsSxssp7dRUtGikjoByoo2c0BgjBHIViMgHvUgpoi40RgCmPxUpPFRHmhjQIOafiq/2u2SZIWmQSucKueTWd4p1C60y3jMGB5hI3dxQkJvU0LzULawjL3EgXHbua5XUPFMtw4S2URIDw55Ye/wDOqNjpt1rMVxcGVneMfxHJJrPNpOHKGGTcDjG01SsS2drpmp6XpVgXN49xNJ8zk5yT6Y7Vg6tfSeIdThW3iI4CKv8AM1LpXhS8u2WS6HkQnnn7x/Cux07R7PTV/wBHiXfk/Owy30zTILVvF5FvHFnOxQv5CpaKKCQrnPGFgZLVb6LIlt+pHpmujqrqUD3OnzwxkBnQgZGaTGiHRL9dR02OYfeA2v8AUVauLhIPL39ZHCKPUmue8GkwJc2cqbJkbcQTSvfG/wDFiWpO6C3OVH+1jrVBY6aiiikIKKKKACkpaKACiiigAooooAKKKKACua8cHGmw+8ldLWR4msftukSADLxDev4UN2GtzD8FX+JZbR24PzIP51v+IZnj0x44QTLMRGgHcmvOrG5ezvI506owP1r0KF5dSubK8iAFsiknd1JPpSkMi8L6VJp9ozz8Sy8lfStuiigkKaRzTqa1S0NGPq3hqz1OTzuYpsYyvQ/UVjf8IO+//j7Xb/u812SnIrP1HXLHTmKTSZkA+4vJppBcrS6Va6foU1uMbNpLFu5rj/DDlNahwCeccVd1zxJJqqfZLSJljbqOpam6dCmgxm+vSPtLKRFBn5vqaexXQueN7zbNbxxvh1BJweRXNpql6OBdSDH+1UF3dSXdy80zEu5yagzxTWgzTGu6iBj7U9Qvqt8+d11L/wB9GqVJQFy7YXLRahBMXPyyAkn611fjVvO023kU7l3Z4+lcQCcjHWtyw1XyUay1KPzYc4IPVKBGx4HuYQksDMBIzZA9a7AKoOQBn6V53/Y5kk8/RrkOOy7sMtW7WfxNbSKBHPIAcbWGQaTt1Fud3RTIi7RIZFCuVG4DsacTgZPApkhRWDrviSKwTyrVllnPcchao2XjIBQt7bnd3dP8KLDsdbSVzk3jKxRcxxyOfTpWPdeLb+5Ro7aMR5PVRkgUBY6PULIWd1Pq0TtuEeHTsa5jwo5l18SMclgSTWfLqepPE8UsspR/vAjrWh4MQnWc/wB1CaaGegUUUUiQooooAKKKKACiiigAooooAKKKKACmsAykHoadWT4juJrbS5HgkKNjqOtJ7DRwuv2iWWrTxRkFM5AHbPar1t4rvLa0it4kjAjGMkdayIyZ7tfOJcseSx5Nd7p2h6Y1urNZxsSOrc0XtoUyGw8XWdx8twpgb8xWyL60K7hcR49d1cFr9jbWaxm3j2FjzyT/ADrHDMOhNNWaE0d3rHim2tUaKzPmz9M/wrVPT/GCldl8hDf3lHFUfCthbXtwWuYhIQcjJNbuv6ZZfYWf7NGGUcEDFRKVhpdC9aapbS24l89NpzyTiub1ZNBa9kuZLl5Hc7mRD1NcszsBsDHaO2aiJq0kBty61b24K6ZZpA2eJG5asi4uJbmUyTSNI57sc1H6U2mAUUtFIDV0LQpdYeTa2xIx94+vYVn3VtLaTvDMpV0OCDXofg+JI9DRkUAsxLH1rF8eQxrNbyhAHYEE+tTfUDj+hyKcWLHcSST1Jrb0mytp9Fv5pYg0kaEoxJ44rDNNMCSOaSJgY3ZT6g4rQt9d1KAYS7kx7nP86y6cKq7Cxuf8JRquMfac/gKcuq6tq0i2scrsWAG1f5msMV33gqCJdMaYRr5jOQW74obYtETaT4YtbJd9wBcTHuw4H0q7eaJp94mJbdQccMvBFaNFTZMV2cHq/hK4tEMto5njHVcfMP8AGszRdR/su/ErpuQ/K6kdq9OrgPGMMUOsjykVN0YY4HU5PNC0He520H2W8t0mjSN0cZB2inxWdtDL5sUKI+MZUYrmfA88rJNCzkxryF9DxXW03FIQUUUUCCiiigAooooA/9k=",
              "FileID": 0
            });*/

            if (currAdded.length > 0) {

              for (var i = 0; i < currAdded.length; i++) {
                this.files[this.files.length] = this.mapItem(this.dataURLtoFile("data:image/" + currAdded[i]["Name"].split('.')[1] + ";base64," + currAdded[i]["FilePayload"], currAdded[i]["Name"]), ClientAction.New, 1);
              }

              this.dfms.assign(p_model, currPath + ".AddedFiles", [], true);

              this.files.sort((a, b) => (a.FileOrder > b.FileOrder) ? 1 : -1)

              this.calculatePaths(true);
            }
          }
        }
        this.fileUploadService.filesNumber = this.files.length;
      }
    });

    this.s4 = this.filesSubmitEndRequest.subscribe(() => {
      for (var i = 0; i < this.files.length; i++) {
        this.files[i].Action = ClientAction.Old;
      }
    });

    if (typeof this.model != "undefined" && this.model) {
      if (typeof this.files == "undefined" || !this.files) {
        this.files = [];
      }

      this.getImages(this.model);

    }

    if (this.defaultCollapse != null && typeof this.defaultCollapse != "undefined" && this.defaultCollapse == true) {
      this.toggleCollapse();
    }

    this.s6 = this.fileUploadService.clearFiles.subscribe(data => {

      if (data != null && Object.keys(data).length > 0) {
        this.shownFiles = [];
        this.files = [];
        this.fileUploadService.files = [];
        // use this property "filesInfo" if you want to access info about images in preSubmitJS event
        this.fileUploadService.filesInfo = [];
        this.fileUploadService.filesToRemove = [];
        this.fileUploadService.filesNumber = this.files.length;
      }
    }, error => { })

    this.getMediaRights(this.model);
    this.checkProXSign();
  }



  getMediaRights(model) {

    var fModel = new RequestModel;
    fModel.data = {};
    fModel.url = "api/media/mediarights";

    if (model != null && model["SerializationObjectFormLink"] != null) {
      fModel.data["SerializationObjectFormLink"] = model["SerializationObjectFormLink"];
    }

    this.restService.getDataPOST(fModel).subscribe(data => {
      if (data != null && typeof data != "undefined") {

        this.fileDataRight.DeleteRight = data["DeleteRight"];
        this.fileDataRight.WriteRight = data["WriteRight"];
      }
    }, error => {

    });

  }

  hasDeleteRight() {

    if (this.fileDataRight != null && this.fileDataRight.DeleteRight == true) {
      return true;
    }

    return false;
  }

  hasWriteRight() {

    if (this.fileDataRight != null && this.fileDataRight.WriteRight == true) {
      return true;
    }

    return false;
  }

  getImages(p_model) {
    if (typeof p_model["Medias"] != "undefined" && p_model["Medias"]) {
      for (var i = 0; i < p_model["Medias"].length; i++) {
        if (this.type == p_model["Medias"][i]["Category"]) {
          if (this.type == 3 && p_model["Medias"][i]["FileSectionType"] == this.filesectiontype) {
            var mapped = new FileDataModel(p_model["Medias"][i]);
            mapped.Action = ClientAction.Old;
            this.files.push(mapped);
          }
          else if (this.type != 3) {
            var mapped = new FileDataModel(p_model["Medias"][i]);
            mapped.Action = ClientAction.Old;
            this.files.push(mapped);
          }
        }
      }
    }

    if (this.onlyOneFileAllowed) {
      this.files.sort((a, b) => a.Id - b.Id); // Sort ascending
      this.files = [this.files[this.files.length - 1]]; // Pick the last element (highest Id)
    }

    //readonly images of subdocuments
    if (this.fileUploadService.imagesPath != null && this.fileUploadService.imagesPath.length > 0) {
      for (var j = 0; j < this.fileUploadService.imagesPath.length; j++) {
        var currPath = this.fileUploadService.imagesPath[j];

        var currMedias = this.dfms.getValue(p_model, currPath + ".Medias"); //p_model[currPath]["Medias"];

        if (currMedias != null && currMedias.length > 0) {
          for (var i = 0; i < currMedias.length; i++) {
            if (this.type == currMedias[i]["Category"]) {
              var mapped = new FileDataModel(currMedias[i]);
              mapped.ReadOnly = true;
              mapped.Action = ClientAction.Old;
              this.files.push(mapped);
            }
          }
        }
      }
    }

    if (this.files.length > 0) {
      this.files.sort((a, b) => (a.FileOrder > b.FileOrder) ? 1 : -1)
      this.calculatePaths(false);
    }

    this.fileUploadService.filesNumber = this.files.length;
    // use this property "filesInfo" if you want to access info about images in preSubmitJS event
    this.fileUploadService.filesInfo.push(...this.files);
  }

  ngAfterContentInit() {

    this.changeDetection.detectChanges();

    if (this.dropArea) {
      this.dropArea.nativeElement.addEventListener('dragenter', this.dragEnter, false)
      this.dropArea.nativeElement.addEventListener('dragleave', this.dragLeave, false)
      this.dropArea.nativeElement.addEventListener('dragover', this.dragOver, false)

      this.globalInstance = this.renderer.listen(this.dropArea.nativeElement, 'drop', (e) => {

        if (this.fileDataRight.WriteRight == true) {
          e.preventDefault();

          if (typeof this.files == "undefined") {
            this.files = [];
          }

          for (var i = 0; i < e.dataTransfer.files.length; i++) {
            if (this.checkFile(e.dataTransfer.files[i])) {
              this.files[this.files.length] = this.mapItem(e.dataTransfer.files[i], ClientAction.New);
            }
          }

          this.calculatePaths();
          this.fileUploadService.filesNumber = this.files.length;
          // use this property "filesInfo" if you want to access info about images in preSubmitJS event
          this.fileUploadService.filesInfo = this.files;
          this.dropareaActive = false;
          this.changeDetection.detectChanges();

        }
      });

      this.globalInstance = this.renderer.listen(this.dropArea.nativeElement, 'dragenter', (e) => {
        this.dropareaActive = true;
      });
      this.globalInstance = this.renderer.listen(this.dropArea.nativeElement, 'dragleave', (e) => {
        this.dropareaActive = false;
      });

    }

    this.actionsService.formActionsReceived.subscribe(data => {
      this.fileDataActions = this.actionsService.getTargetActions();
    });

  }

  /*********************** File Functions *************************/

  closeExists() {
    this.alreadyExists = false;
  }

  showErrorMessage(message: string) {

    this.utility.reqStatus = ResponseStatus.MessageOnly;
    this.utility.reqMessage = message;
    this.utility.reqResponse = true;

    /*setTimeout(() => {
      this.resetResponseStatus();
    }, 5000);*/
  }

  resetResponseStatus() {
    this.utility.reqStatus = ResponseStatus.Error;
    this.utility.reqResponse = false;
  }

  checkFile(file: File): boolean {

    var mbs = file.size / (1024 ** 2);
    if (mbs > environment.maxFileSizeInMb) {
      this.showErrorMessage("Največja dovoljena velikost datoteke je presežena. Dovoljena velikost: " + environment.maxFileSizeInMb + " mb");
      return false;
    }

    // check if already exists
    if (!(this.customFileTextAppend && this.customFileTextAppend.length > 0)) {
      if (this.files != null && typeof this.files != "undefined" && this.files.length > 0) {
        let indx = this.files.findIndex(x => x.Name == file.name);
        if (indx >= 0) {
          this.alreadyExists = true;
          this.showErrorMessage(this.translationsService.translate('FileAlreadyExists'));
          return false;
        }
      }

      //check for fileUploadService fileInfo, array shared between file upload components
      if (this.fileUploadService.filesInfo && typeof this.fileUploadService.filesInfo != "undefined" && this.fileUploadService.filesInfo.length > 0) {
        let indx = this.fileUploadService.filesInfo.findIndex(x => x.Name == file.name);
        if (indx >= 0) {
          this.alreadyExists = true;
          this.showErrorMessage(this.translationsService.translate('FileAlreadyExists'));
          return false;
        }
      }

      if (this.model["Medias"]) {
        if (this.model["Medias"].filter(i => i.Name == file.name).length > 0) {
          this.alreadyExists = true;
          this.showErrorMessage(this.translationsService.translate('FileAlreadyExists'));
          return false;
        }
      }

    }

    if (this.availableExtensions.length > 0) {
      var fileExtentionSplit = file.name.split(".");
      for (var i = 0; i < this.availableExtensions.length; i++) {
        if (fileExtentionSplit[fileExtentionSplit.length - 1].toLowerCase() == this.availableExtensions[i].toLowerCase()) {
          this.resetResponseStatus();
          return true;
        }
      }

      this.showErrorMessage(this.translationsService.translate('UnsupportedFileFormat') + " " + this.availableExtensions.toString().split(",").join(", "));

      return false;
    }

    this.resetResponseStatus();
    return true;
  }

  onFileChange(event: any, obj: any): void {
    const inputEl = event.target as HTMLInputElement;

    if (!inputEl.files || inputEl.files.length === 0) {
      return;
    }

    let newFile: any = null;

    for (let i = 0; i < inputEl.files.length; i++) {
      const file = inputEl.files[i];

      if (this.checkFile(file)) {

        if (this.onlyOneFileAllowed) {
          this.files = [];

          if (this.fileUploadService.filesInfo?.length > 0) {
            this.fileUploadService.filesInfo = this.fileUploadService.filesInfo.filter(
              f => f && f.FileSectionType !== this.filesectiontype
            );
          }

          if (this.model["Medias"]) {
            this.model["Medias"] = this.model["Medias"].filter(
              m => m.FileSectionType !== this.filesectiontype
            );
          }
        }

        newFile = this.mapItem(file, ClientAction.New);

        if (obj && newFile) {
          newFile.Parameters = JSON.stringify({ Id: obj.Id });
        }

        if(this.isInNgFor === true){
          newFile.Parameters = JSON.stringify({ Id: this.model.Id });
        }

        this.files.push(newFile);
        this.fileUploadService.filesInfo.push(newFile);
      }
    }

    // Reset file input value
    inputEl.value = '';

    this.calculatePaths();
    this.fileUploadService.filesNumber = this.files.length;
  }


  getShownFiles(obj: any) {
    return this.shownFiles.filter(file => {
      try {
        const json = JSON.parse(file.parameters);
        return json?.Id === obj.Id;
      } catch {
        return false;
      }
    });
  }

  getCurrentFiles(): any[] {
    return this.isInNgFor ? this.getShownFiles(this.model) : this.shownFiles;
  }
  
  handleFileClick(file: any): void {
    if (this.isInNgFor) {
      this.fileClickedInline(file);
    } else {
      this.fileClicked(file);
    }
  }
  


  getShownFilesEmpty() {
    return this.shownFiles.filter(i => (!i.parameters || i.parameters.length == 0));
  }

  public openFileDialog(): void {
    let event = new MouseEvent('click', { bubbles: false });
    this.fileUpload.nativeElement.dispatchEvent(event);
  }

  removeFile(skipConfirm = false) {
    //this.fileUpload.nativeElement.value = [];
    //this.files = [];

    if (!skipConfirm) {
      this.toConfirm = !this.toConfirm;
    }

    for (var i = 0; i < this.files.length; i++) {
      if (this.files[i].Name == this.selectedFile.Name) {
        let deletedFile = this.files[i];
        this.deletedFiles.push(this.files[i]);
        this.files.splice(i, 1);

        this.fileUploadService.filesInfo = this.fileUploadService.filesInfo.filter(i => i.Name != this.selectedFile.Name);

        if (this.model["Medias"]) {
          for (var k = 0; k < this.model["Medias"].length; k++) {
            if (this.model["Medias"][k]["FileID"] == deletedFile["Id"]) {
              this.model["Medias"].splice(k, 1);
            }
          }
        }

        for (var j = 0; j < this.filePaths.length; j++) {
          if (deletedFile.Name == this.filePaths[j].name) {
            this.filePaths.splice(j, 1);
            this.shownFiles = this.filePaths.slice();

            break;
          }
        }

        if (this.files.length > 0) {
          this.selectedFile = this.files[0];
          this.imgPath = this.filePaths[0].path;
          this.calibrateImgArray();
        }

        this.calculatePaths();

        break;
      }
    }

    //this.fileUploadService.filesNumber = this.files.length;
    // use this property "filesInfo" if you want to access info about images in preSubmitJS event
    //this.fileUploadService.filesInfo = this.files;

  }

  deleteFileFe(item) {
    this.selectedFile = item;
    this.removeFile();
    this.toConfirm = false;
  }

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  async calculatePaths(addedFromBrowser = true) {
    this.showLoader = true;
    this.filePaths = [];

    for (var i = 0; i < this.files.length; i++) {
      try {
        // somewhere this.files is reset to [] 
        // check 
        if (this.files != null && this.files.length > 0) {
          var fileName = this.files[i].Name.split(".")[0];
          var filenamefull = this.files[i].Name;
          var extension = this.files[i].Name.split(".")[1].toLowerCase();

          if (fileName.length > 10) {
            fileName = fileName.substring(0, 10) + "...";
          }

          let url = "";

          if ((!addedFromBrowser && this.type != 3) || (this.enableProXSign)) {
            let model = new RequestModel;
            model.url = "api/media/GetPreview";
            model.data = { Id: this.files[i]["FileID"], DocumentId: this.model["Id"], ReturnFullSize: false, Width: 350, Height: 350 };
            //model.responseType = "application/octet-stream";
            //model.contentType = "application/json";
            this.restProviderService.serializer = null;

            if (this.enableProXSign) {
              this.proXSignFileDownloading = true;
            }
            //var result = await this.restProviderService.getDataPOST(model).toPromise();
            var result = await this.restProviderService.imagePostRequest(model).toPromise();

            if (this.enableProXSign) {
              this.proXSignFileDownloading = false;
            }

            //var result = this.readWGFile(model,this.files[i].Name);
            //console.log("WG Image result", result);

            if (this.enableProXSign) {
              this.files[i].base64 = result["Base64Img"];
            } else {
              this.files[i].File = this.dataURLtoFile("data:text/plain;base64," + result["Base64Img"], this.files[i].Name);
            }

          }

          if ((addedFromBrowser || this.type == 1) && this.files[i].File) {
            url = URL.createObjectURL(this.files[i].File);
          }

          let item = { id: i, path: url, feName: fileName, name: filenamefull, extension: extension, size: "", parameters: this.files[i].Parameters };

          if (this.type != 3) {
            item.size = FileUtil.getFriendlyFileSize(this.files[i].File.size)
          }

          this.filePaths.push(item);
        }

        if (this.filePaths.length > 0 && this.type != 2) {
          this.imgPath = this.filePaths[0].path;
        } else if (this.type == 2) {

          if (this.filePaths.length > 0) {
            this.ddAreaDisplay = "none";
          } else {
            this.ddAreaDisplay = "block";
          }

        }

        this.selectedFile = this.files[0];
        this.calibrateImgArray();
        this.showLoader = false;
      } catch (e) {
      }
    }

    this.showLoader = false;
  }

  fileClickedInline(file) {
    for (var i = 0; i < this.files.length; i++) {
      if (this.files[i].Name == file.name) {
        this.selectedFile = this.files[i];
      }
    }
  }

  fileClicked(file) {

    for (var i = 0; i < this.files.length; i++) {
      if (this.files[i].Name == file.name) {
        this.selectedFile = this.files[i];
      }
    }

    this.imgPath = file.path;
    this.showSelected = true;

    setTimeout(() => {
      this.showSelected = false;
      this.changeDetection.detectChanges();
    }, 3000);
  }

  download() {
    if (this.downloadInProgress) {
      return;
    }

    if (typeof this.selectedFile != "undefined" && this.selectedFile != null) {
      if (this.selectedFile.Id > 0) {
        // handler isnt used anymore, use api
        //var href = "storage/?file&" + this.selectedFile.Id + "&mode=0"; //window.URL.createObjectURL(this.selectedFile.File);;
        //window.open(href, '_blank');

        var model: RequestModel = new RequestModel;
        model.url = "api/media/getfile";
        model.data = {
          "Id": this.selectedFile.Id,
          "FileName": this.selectedFile.Name
        };

        this.downloadInProgress = true;

        this.restService.getDataPOST(model).subscribe(data => {
          const linkSource = `data:${data["MimeType"]};base64,${data["Base64"]}`;
          const downloadLink = document.createElement("a");
          downloadLink.href = linkSource;
          downloadLink.download = this.selectedFile.Name;
          downloadLink.click();
          this.downloadInProgress = false;
        }, error => {
          this.downloadInProgress = false;
        });
      }
    }
  }

  downloadFileFe(item) {
    if (typeof item != "undefined" && item != null) {
      if (item.Id > 0) {
        // handler isnt used anymore, use api
        //var href = "storage/?file&" + item.Id + "&mode=0"; //window.URL.createObjectURL(this.selectedFile.File);;
        //window.open(href, '_blank'); 
        var model: RequestModel = new RequestModel;
        model.url = "api/media/getfile";
        model.data = {
          "Id": item.Id,
          "FileName": item.Name
        };

        this.restService.getDataPOST(model).subscribe(data => {
          const linkSource = `data:${data["MimeType"]};base64,${data["Base64"]}`;
          const downloadLink = document.createElement("a");
          downloadLink.href = linkSource;
          downloadLink.download = item.Name;
          downloadLink.click();
        });

      }
    }
  }

  openFileEditor() {
    let files: any[] = [this.selectedFile.File];

    const fileListEvent = new CustomEvent("awesome", {
      bubbles: true,
      detail: { target: () => { fileList: files } },
    });
    Object.defineProperty(fileListEvent, 'target', { writable: false, value: { files: files } });

    let format = this.selectedFile.Name.split(".")[1];


    this.photoEditorService.open(fileListEvent, {
      autoCrop: false,
      viewMode: 1,
      format: format,
      hideModalHeader: true,
      applyBtnText: "Potrdi",
      closeBtnText: "Prekliči",
      modalMaxWidth: (window.innerWidth - (window.innerWidth / 5)).toString() + "px"
    }).subscribe(data => {

      for (var i = 0; i < this.files.length; i++) {
        if (this.files[i].File.name == this.selectedFile.File.name) {

          if (data.file) {
            if (this.checkFile(data.file)) {
              this.removeFile(true);
              this.files.push(this.mapItem(data.file, ClientAction.New));
            }
          }

          break;

        }
      }

      this.calculatePaths();

    });
  }


  openFileExplorer() {
    //this.fileExplorer.open();
    this.dialog.open(SemFileExplorerDialogComponent, {
      data: {
        files: this.files,
        availableExtensions: this.availableExtensions,
        type: this.type,
        model: this.model,
        shownFiles: this.shownFiles
      },
      height: "calc(100% - 100px)",
      width: "calc(100% - 100px)",
      autoFocus: false
    }).afterClosed().subscribe((t: any) => {

      this.files.forEach((element) => {

        try {
          var inModel = this.model.Medias.filter(i => i.Id == element.Id)[0];
          if (inModel) {
            inModel.Title = element.Title;
            inModel.Description = element.Description;
            inModel.Annotations = element.Annotations;
          }
        }
        catch (e) {
        }

      });

    });

  }

  openFileInExplorer(chosenFile: any) {

    if (this.selectedFile) {

      this.selectedFile.Title = this.selectedFile.Name;

      this.dialog.open(SemFileExplorerDialogComponent, {
        data: {
          files: [this.selectedFile],
          availableExtensions: this.availableExtensions,
          type: this.type,
          model: this.model,
          shownFiles: this.shownFiles,
          readOnlyFields: true
        },
        height: "calc(100% - 100px)",
        width: "calc(100% - 100px)",
        autoFocus: false
      });

    }

    /*if(chosenFile){
      let fileData = this.files.find(x => x.Name == chosenFile.name);
      if(fileData){

        fileData.Title = fileData.Name;

        this.dialog.open(SemFileExplorerDialogComponent, {
          data: {
            files: [fileData],
            availableExtensions: this.availableExtensions,
            type: this.type,
            model: this.model,
            shownFiles: this.shownFiles,
            readOnlyFields: true
          },
          height: "calc(100% - 100px)",
          width: "calc(100% - 100px)",
          autoFocus: false
        });
      }
    }*/



  }

  /*********************** DRAG N DROP Functions *************************/

  dragEnter(e) { e.preventDefault(); }
  dragLeave(e) { e.preventDefault(); }
  dragOver(e) { e.preventDefault(); }

  /*********************** slide Functions *************************/

  slide(direction) {
    if (this.files.length > 5) {
      switch (direction) {

        case "left":
          if (this.index > 0) {
            this.index--;
          }
          break;

        case "right":
          if (this.index < this.files.length - 5) {
            this.index++;
          }
          break

        default:
          break;
      }
    }
    this.calibrateImgArray();
  }

  calibrateImgArray() {
    try {
      if (this.type != 2 && this.type != 3) {
        if (this.files.length < 6) {
          this.shownFiles = this.filePaths;
        }
        else {

          if ((this.files.length - this.index) < 5) {
            return;
          } else {
            let temparr = this.filePaths.slice();
            this.shownFiles = temparr.splice(this.index, 5);

          }
        }
        for (var i = 0; i < this.shownFiles.length; i++) {
          this.shownFiles[i]["order"] = i;
        }
      } else {
        this.shownFiles = this.filePaths.slice();
      }
    } catch (e) {
      //console.log("Error migrating images: ", e);
    }

  }

  toggleCollapse() {
    this.collapse = !this.collapse;
    this.collapseChanged.emit(this.collapse);
  }

  ngOnDestroy(): void {

    try {
      for (var i = 0; i < this.filePaths.length; i++) {
        var splited = this.filePaths[i]["path"].split("/");
        URL.revokeObjectURL(this.filePaths[i]["path"]);
        URL.revokeObjectURL(splited[3]);
      }
    } catch (e) {
      //console.log("Error cleaning browser files: ", e);
    }

    this.filePaths = [];
    this.files = [];
    this.shownFiles = [];
    this.globalInstance;

    this.s1.unsubscribe();
    this.s2.unsubscribe();
    this.s3.unsubscribe();
    this.s4.unsubscribe();
    this.s6.unsubscribe();

  }

  generateUniqueText(): string {
    return '_' + Math.random().toString(36).substr(2, 5);
  }

  mapItem(file: File, action: ClientAction, type: number = null, mediaId: any = null) {
    let fileDataModel = new FileDataModel(null);
    fileDataModel.Name = file.name;
    fileDataModel.Action = action;
    fileDataModel.Size = file.size;
    fileDataModel.File = file;

    if (this.customFileTextAppend && this.customFileTextAppend.length > 0 && mediaId == null) {
      const fileNameParts = file.name.split('.');
      const uniqueText = this.generateUniqueText();

      if (fileNameParts.length > 1) {
        // There is an extension
        const fileExtension = fileNameParts.pop(); // Get the file extension
        const baseFileName = fileNameParts.join('.'); // Join the remaining parts to get the base file name
        fileDataModel.Name = `${baseFileName}${uniqueText}${this.customFileTextAppend}.${fileExtension}`;
      } else {
        // There is no extension
        fileDataModel.Name = `${file.name}${uniqueText}${this.customFileTextAppend}`;
      }
    }

    if (mediaId) {
      fileDataModel.Id = mediaId;
      fileDataModel.FileID = mediaId;
    }

    if (typeof type != "undefined" && type) {
      fileDataModel.Category = type;
    } else {
      fileDataModel.Category = this.type;
    }

    if (this.filesectiontype) {
      fileDataModel.FileSectionType = this.filesectiontype;
    }

    fileDataModel.FileOrder = this.files.length + 1;

    return fileDataModel;
  }

  readFile(url) {
    var request = new XMLHttpRequest();
    request.open('POST', url, true);
    request.responseType = 'blob';
    request.onload = function () {
      var reader = new FileReader();
      reader.readAsDataURL(request.response);
      reader.onload = function (e) {
      };
    };
    request.send();
  }

  readWGFile(model, filename) {
    var request = new XMLHttpRequest();
    request.open('POST', "api/media/GetPreview", true);
    request.setRequestHeader('Authorization', "Bearer " + this.restProviderService.getCookie("_galis_access_token"));
    request.responseType = 'blob';
    request.onload = function () {
      var retrievedFile = new File(request.response, filename);
      return retrievedFile;
    };
    request.send(model);
  }

  toUTF8Array(str) {
    var utf8 = [];
    for (var i = 0; i < str.length; i++) {
      var charcode = str.charCodeAt(i);
      if (charcode < 0x80) utf8.push(charcode);
      else if (charcode < 0x800) {
        utf8.push(0xc0 | (charcode >> 6),
          0x80 | (charcode & 0x3f));
      }
      else if (charcode < 0xd800 || charcode >= 0xe000) {
        utf8.push(0xe0 | (charcode >> 12),
          0x80 | ((charcode >> 6) & 0x3f),
          0x80 | (charcode & 0x3f));
      }
      // surrogate pair
      else {
        i++;
        // UTF-16 encodes 0x10000-0x10FFFF by
        // subtracting 0x10000 and splitting the
        // 20 bits of 0x0-0xFFFFF into two halves
        charcode = 0x10000 + (((charcode & 0x3ff) << 10)
          | (str.charCodeAt(i) & 0x3ff));
        utf8.push(0xf0 | (charcode >> 18),
          0x80 | ((charcode >> 12) & 0x3f),
          0x80 | ((charcode >> 6) & 0x3f),
          0x80 | (charcode & 0x3f));
      }
    }
    return utf8;
  }

  confirm() {
    this.toConfirm = !this.toConfirm;
  }

  onDrop(src, trg) {
    this._moveRow(src, trg);
  }

  onDropFe(da) {
    this.onDrop(da.src, da.tar);
  }

  _moveRow(src, trg) {

    let id: number = 0;
    id = src.order;
    src.order = trg.order;
    trg.order = id;


    for (var i = 0; i < this.shownFiles.length; i++) {
      if (this.shownFiles[i].name == src["name"]) {
        this.shownFiles[i].order = src.order;
      } else if (this.shownFiles[i].name == trg["name"]) {
        this.shownFiles[i].order = trg.order;
      }
    }

    for (var i = 0; i < this.files.length; i++) {
      if (this.files[i].Name == src["name"]) {
        this.files[i].FileOrder = src.order;
      } else if (this.files[i].Name == trg["name"]) {
        this.files[i].FileOrder = trg.order;
      }
    }

    this.files.sort((a, b) => (a.FileOrder > b.FileOrder) ? 1 : -1)
    this.shownFiles.sort((a, b) => (a.order > b.order) ? 1 : -1)

  }

  runProtocol() {
    const downloadLink = document.createElement("a");

    downloadLink.href = this.protocolName + this.restProviderService.getCookie("_galis_access_token") + "/" + this.model["Id"];
    downloadLink.click();
  }

  setAsDefault() {
    let fileName = "";
    let fileOrder = this.selectedFile["FileOrder"];
    this.files.forEach(file => {
      if (file["FileOrder"] == 1) {
        file["FileOrder"] = fileOrder
        fileName = file["Name"];
      }
    })

    this.model["Medias"].forEach(element => {
      if (element["Name"] == this.selectedFile["Name"]) {
        element["FileOrder"] = 1;
      } else if (element["Name"] == fileName) {
        element["FileOrder"] = fileOrder;
      }
    });


    this.selectedFile["FileOrder"] = 1;
    this.files.sort((a, b) => (a.FileOrder > b.FileOrder) ? 1 : -1)
    this.shownFiles.sort((a, b) => (a.FileOrder > b.FileOrder) ? 1 : -1)
    this.calculatePaths();
  }

  fileDataAction(fa) {

    let dialogRef = this.dialog.open(SemDialogComponent, {
      width: '675px', data:
      {
        entityModel: fa.Parameters.model,
        title: fa.Parameters.title,
        model: this.model,
        projection: ['Medias', 'Medias.Id', 'Medias.Category', 'Medias.Type', 'Medias.Name', 'Medias.UploadDate'],
        type: 3,
        searchFields: [{ PropertyName: "Title", Type: "Text", Title: "Title" }]
      }
    });

    dialogRef.afterClosed().subscribe((data: any) => {
      this.files[this.files.length] = this.mapItem(data.file, ClientAction.Linked, null, data.mediaId);
      this.calculatePaths();
    });

  }



















  /////////////// PROXSIGN

  selectedSubject: string = "";
  error: boolean = false;
  certLoad: boolean = false;




  checkProXSign() {

    if (this.enableProXSign) {

      this.certLoad = true;
      this.error = false;

      this.proXSignService = this.injector.get(ProXSignService);
      this.proXSignService.loadScript().then(() => {
        if (this.proXSignService.isLibraryLoaded()) {
          this.proXSignLib = this.proXSignService.getLibrary();

          if (this.proXSignLib) {
            // Initialize and wait for the callback before selecting certificate
            this.proXSignLib.initialize(() => {
              console.log("ProXSign successfully initialized.");
              console.log("proXSign initialized:", this.proXSignLib);
              this.proXSignAvailable = true;

              this.versionNumber = this.proXSignLib.version;
              this.versionText = "Podpisna komponenta proXSign je pripravljena";

              this.proXSignLib.updateLicense({ fileURL: this.proXSignService.licenceUrl, forceUpdate: true, fileContent: this.proXSignService.licenceContent }, this.callbackLicense, this.callbackLicenceError);

              this.error = false;
              this.certLoad = false;

              var certInfo = this.dfms.getValue(this.model, this.certProp);

              if (certInfo && certInfo.length > 0) {
                var certInfoJson = JSON.parse(certInfo);
                this.selectedSubject = certInfoJson.subject;
              }

            }, this.callbackError);
          } else {
            console.error("proXSign library is still undefined after loading.");
            this.certLoad = false;
          }
        } else {
          this.certLoad = false;
        }
      }).catch(error => {
        console.error("Failed to load proXSign:", error);
        this.certLoad = false;
      });
    }
  }

  callbackError = (jqXHR, textStatus, errorThrown) => {
    console.error("ProXSign Error:", jqXHR, textStatus, errorThrown);
    this.error = true;
    this.certLoad = false;
  }

  signDocument() {
    this.loading = true;
    DynamicLoadingUtil.loader.showLoader = true;

    var base64 = this.files[0].base64;

    var certInfo = this.dfms.getValue(this.model, this.certProp);

    var props = proXSignUtil.props;
    if (certInfo && certInfo.length > 0) {
      var certInfoJson = JSON.parse(certInfo);
      props.certificates = [certInfoJson];
    }

    props.bytes = [base64];

    this.proXSignLib.signPDF(props, this.callbackSign, this.callbackError);
  }

  callbackSign = (data, textStatus) => {

    if (data.error == 1) {
      this.proXSignAvailable = false;

      this.dfms.assign(this.model, this.certProp, JSON.stringify(data.certificates[0]), true);

      var file = this.dataURLtoFile("data:text/plain;base64," + data.result, "signed_" + this.files[0].Name);

      var newFile = (this.mapItem(file, ClientAction.New));
      newFile.FileSectionType = this.proXSignFileSectionType;

      if (newFile) {
        this.files.push(newFile);
      }
      this.fileUploadService.filesNumber = this.files.length;
      // use this property "filesInfo" if you want to access info about images in preSubmitJS event
      this.fileUploadService.filesInfo.push(newFile);

      this.saveFormReq.emit("");

      this.loading = false;
      DynamicLoadingUtil.loader.showLoader = false;
    }
    else if (data.error == -3) {
      this.loading = false;
      DynamicLoadingUtil.loader.showLoader = false;
      return;
    }
    else {
      console.log(data);

      this.loading = false;
      DynamicLoadingUtil.loader.showLoader = false;

      const dialogRef = this.dialog.open(SemConfirmDialogComponent, { data: { cssclass: "conf-error", type: DialogType.NotificationSuccess, text: "Pri podpisovanju dokumenta vloge je prišlo do napake. Prosimo, preverite veljavnost digitalnega potrdila. Koda napake: " + data.error } });

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 1);

      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  callbackLicense = (data, textStatus) => {

    var s;
    if (data.error == 1) {
    }   // SIGN ERROR
    else {
      s = "Error code:  " + data.error; //Error codes are described in xErrors.txt file
      s += "\r\nError message:  " + data.errorMessage;
      console.log(s);
    }

  }

  callbackLicenceError = (jqXHR, textStatus, errorThrown) => {

    var s = "Error :  " + JSON.stringify(jqXHR); // General error in ajax call
    console.log("Napaka : proXSign komponenta se ne odziva");
    console.log(s);
  }

  private titleCache = new Map<any, string>();

  getBoundedProp() {
    var data = this.dfms.getValue(this.model, this.boundedProperty);

    if(data && data.length > 0){
      return data?.slice().sort((a, b) => a.Id - b.Id);
    }

    return [];
  }

  evalBoundedCondition() {

  }

  evaluateBoundedTitle(item: any): string {
    if (this.titleCache.has(item)) return this.titleCache.get(item)!;

    const result = this.boundedTitleEval.replace(/{{\s*item\.(\w+)\s*}}/g, (_, key) => {
      return item[key] ?? '';
    });

    this.titleCache.set(item, result);
    return result;
  }

  evaluateBoundedCondition(obj: any): boolean {
    if (!this.boundedConditionEval || this.boundedConditionEval.length == 0) {
      return true;
    }
    try {
      return Function('obj', `return ${this.boundedConditionEval};`)(obj);
    } catch {
      return false;
    }
  }

  trackByFileId(index: number, file: any): any {
    return file.id ?? file.name ?? index;
  }

}


